import React from "react";

const SeriesPage = () => {
  return (
    <div>
      Lorem ipsum dolor sit, amet consectetur adipisicing elit. Accusantium quis
      labore itaque odio earum, ducimus quam sint veniam minus, eaque autem
      fugit. Animi quo minus commodi voluptatibus quisquam? Vel, ab?
    </div>
  );
};

export default SeriesPage;
